import { logger } from "@/infrastructure/services/LoggerService";
/** sessionStorage prefix of the quick-filter chips a list keeps for the tab (OP-8428). */
export const QUICK_FILTERS_STORAGE_PREFIX = "quick-filters:";
/** sessionStorage prefix of the ids and query a list hands to its detail page for prev/next. */
export const LIST_NAV_CONTEXT_STORAGE_PREFIX = "list-nav-context:";
/**
 * Drops what the signed-in user browsed on the lists: chips and navigation contexts hold their typed filter values,
 * and the keys carry no user or organisation, so the next user signing in on the same tab would inherit them.
 */
export function clearListBrowsingState() {
    try {
        const keys = [];
        for (let i = 0; i < sessionStorage.length; i++) {
            const key = sessionStorage.key(i);
            if (key?.startsWith(QUICK_FILTERS_STORAGE_PREFIX) || key?.startsWith(LIST_NAV_CONTEXT_STORAGE_PREFIX)) {
                keys.push(key);
            }
        }
        for (const key of keys)
            sessionStorage.removeItem(key);
    }
    catch (e) {
        logger.error("clearListBrowsingState: could not clear the lists' saved state", e);
    }
}
